import { get } from '../helpers'

export default {
  getAdminUserOrderCounts(userId) {
    return get(`api/admin/users/${userId}/order_counts`)
  }
}
